import pre from './pre';
import cart from './cart.vue';
import config from './config/index.vue';

export default {
    pre,
    components: {
        config,
        cart
    },
    post: () => { },
}
